import dayjs, { Dayjs } from "dayjs";
import HeatMapGrid from "./HeatMap/";
import {
  materialColorsForSelect,
  materialTransparentColors,
} from "../../utils/colors";
import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
interface Props {
  items: any[];
}

const HeatMap = ({ items }: Props) => {
  const currentYear = dayjs().year();
  const startYear = currentYear - 10;
  const [selectedYear, setSelectedYear] = React.useState<string>(
    currentYear.toString()
  );
  const xLabels = new Array(52).fill(0).map((_, i) => `${i + 1}`);
  const yearOptions = Array.from({ length: 11 }, (_, i) =>
    (startYear + i).toString()
  ).sort((a, b) => parseInt(b, 10) - parseInt(a, 10));

  const uniqueSymptoms = items.map((entry) => {
    return {
      dates: entry.dates,
      name: entry.name,
    };
  });

  const filteredSymptoms = uniqueSymptoms.map((item) => {
    const filteredDates = item.dates.filter(
      (date: Dayjs) => date.year().toString() === selectedYear
    );
    return {
      dates: filteredDates,
      name: item.name,
    };
  });

  const data = filteredSymptoms
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((item) => {
      return xLabels.map((month) => {
        const isPresent = item.dates.some(
          (date: Dayjs) => parseInt(month, 10) === date.isoWeek()
        );
        return { item: item.name, present: isPresent ? 1 : 0 };
      });
    });

  const rowColors = filteredSymptoms.map(
    (_, index) =>
      materialColorsForSelect[index % materialColorsForSelect.length].value
  );

  const transparentRowColors = rowColors.map(
    (color) => materialTransparentColors[color]
  );

  return (
    <Box>
      <InputLabel>År</InputLabel>
      <FormControl sx={{ margin: 2 }}>
        <Select
          value={selectedYear.toString()}
          style={{ maxWidth: "170.99px" }}
          onChange={(e) => {
            e.preventDefault();
            setSelectedYear(e.target.value);
          }}
          IconComponent={(e) => (
            <ArrowDropDownIcon cursor="pointer" className={e.className} />
          )}
          data-test="eventlibrary-new-list-color-select"
        >
          {yearOptions.map((option) => {
            return (
              <MenuItem
                key={option}
                value={option}
                sx={{
                  "&:hover": {
                    fontWeight: "700",
                    borderWidth: 3,
                    borderColor: "black",
                  },
                }}
                data-test="event-library-colors-menu-item"
              >
                {option}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <HeatMapGrid
        data={data}
        xLabels={xLabels}
        yLabels={filteredSymptoms
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item) => item.name)}
        // Render cell with tooltip
        cellRender={(x, y, value) => {
          return <div title={`Pos(${x}, ${y}) = ${value.item}`} />;
        }}
        xLabelsStyle={(index) => ({
          fontSize: ".8rem",
          width: "2rem",
        })}
        yLabelsStyle={(index) => ({
          fontSize: ".7rem",
          textTransform: "uppercase",
          color: "black",
          background: transparentRowColors[index],
          paddingRight: "0.5rem",
        })}
        cellStyle={(_x, _y, ratio, index) => ({
          background:
            ratio === 1 ? rowColors[index] : transparentRowColors[index],
          fontSize: ".8rem",
        })}
        cellHeight="2rem"
        xLabelsPos="bottom"
        // onClick={(x, y, value) => alert(`Clicked (${x}, ${y}) = ${value.item}`)}
        // onHover={(x, y, value) => (
        //   <Popper id={`${x}-${y}`} open={true}>
        //     <div>{`Hovered (${x}, ${y}) = ${value}`}</div>
        //   </Popper>
        // )}
        yLabelsPos="left"
        square
      />
    </Box>
  );
};

export default HeatMap;
